<template onload="startTab()">
  <div class="chat container col s12 m12 l10" >
    <div class="tab">
      <button class="tablinks" onclick="openCity(event, 'Eingang')"  @click="inMessages()" >Eingang</button>
      <button class="tablinks" onclick="openCity(event, 'Ausgang')"  @click="outMessages()" >Ausgang</button>
    </div>
    <!-- Tab content -->
    <div id="Eingang" class="tabcontent" style="display:block">
      <div class="card">
        <h3 class=" " style="background-color: #dddddd">{{name}}'s Nachrichten Eingang</h3>
        <div class="comments collection">
          <div class="row" style="background-color: #dddddd">
            <div class="col s1"><p>Foto</p></div>
            <div class="col s1"><p>Von</p></div>
            <div class="col s7"><p>Nachricht</p></div>
            <div class="col s2"><p>Datum:</p></div>
          </div>
          <div v-for="(usermessage, index) in userMessages" :key="index">
            <div class="row" style="margin-top: -20px">
              <div class="col s1"> <img class="deep-purple-text" v-bind:src="usermessage.img" style="height: 50px"></div>
              <div class="col s1"><p> <span class="deep-purple-text">{{usermessage.from}}</span></p></div>
              <div class="col s7"><p> <span class="grey-text text-darken-2">{{usermessage.content}}</span></p></div>
              <div class="col s2"><p>{{usermessage.timestamp}}</p></div>
              <hr>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="Ausgang" class="tabcontent">
      <div class="card">
        <h3 class=" " style="background-color: #dddddd">{{name}}'s Nachrichten Ausgang</h3>
        <div class="comments collection">
          <div class="row" style="background-color: #dddddd">
            <div class="col s1"><p>Foto</p></div>
            <div class="col s1"><p>An</p></div>
            <div class="col s7"><p>Nachricht</p></div>
            <div class="col s2"><p>Datum:</p></div>
          </div>
          <div v-for="(usermessage, index) in userMessages" :key="index">
            <div class="row" style="margin-top: -20px">
              <div class="col s1"> <img class="deep-purple-text" v-bind:src="usermessage.img" style="height: 50px"></div>
              <div class="col s1"><p> <span class="deep-purple-text">{{usermessage.to}}</span></p></div>
              <div class="col s7"><p> <span class="grey-text text-darken-2">{{usermessage.content}}</span></p></div>
              <div class="col s2"><p>{{usermessage.timestamp}}</p></div>
              <hr>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <form @submit.prevent="">
        <div class="field">
          <div class="row" style="background-color: #dddddd"><p>Nachricht erstellen</p></div>
          <p>Empfänger: {{neuePerson}}</p>
          <p>Titel:</p><input type="text" name="titel" v-model="newTitle">
          <p>Message:</p><input type="text" name="message" v-model="newMessage" >
          <p v-if="feedback" class="red-text center">{{feedback}}</p>
          <button style="height: 40px" @click="addMessage()">Absenden</button>
        </div>
      </form>
    </div>
  </div>

</template>

<script>
    import {modulgetRefDB,modulgetRefDBNoSort} from "../../firebase/MainDBManager";
    import {modulAddMessage, modulGetMessages, getImgUser} from "../../firebase/UserMessageDBFunction"
    import Button from "../Button";

    export default {
        name: "UserMessage",
        props: ['name'],
        props:['neuePerson'],
        components: {Button},
        data(){
            let ref;
            return{
                newMessage:null,
                newTitle:null,
                userMessages:[],
                friend:null,
                feedback:false,
                holder:this.name,
                holder2:this.neuePerson,
            }
        },
        created() {
            //User, Friend
            //this.ref=modulgetRefDB('friends','region');
            //modulgetUser(this.ref, 'Stefan', this.friend);
            this.name=this.$route.params.name;

            // //messages
            this.ref=modulgetRefDB('usermessages','timestamp');
            modulGetMessages(this.ref, this.$route.params.name, this.userMessages, 'to');
        },
        methods:{
              addMessage(){
                  if (!this.message){
                      this.ref=modulgetRefDBNoSort('usermessages');
                      modulAddMessage(this.ref,
                          {
                              from: this.$route.params.name,
                              to:this.$route.params.neuePerson,
                              content:this.newMessage,
                              timestamp: Date.now(),
                              title:this.newTitle,
                              img:getImgUser(this.$route.params.name)
                          });
                      this.newTitle="";
                      this.newMessage="";
                  }
                  else{
                      this.feedback="Füllen Sie alle Felder aus"
                  }
              },
            inMessages(){
                this.ref=modulgetRefDB('usermessages','timestamp');
                modulGetMessages(this.ref, this.$route.params.name, this.userMessages, 'to');
            },
            outMessages(){
                this.ref=modulgetRefDB('usermessages','timestamp');
                modulGetMessages(this.ref, this.$route.params.name, this.userMessages, 'from');
            }
        }
    }
</script>

<style scoped>
  .tab {
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
  }

  .tab button {
    background-color: inherit;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
  }

  .tab button:hover {
    background-color: #ddd;
  }

  .tab button.active {
    background-color: #ccc;
  }

  .tabcontent {
    display: none;
    padding: 6px 12px;
    border: 1px solid #ccc;
    border-top: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserMessage/UserMessage.vue